const download = [
  "M11.96 7.3a.5.5 0 0 0-.46-.3h-2V.5A.5.5 0 0 0 9 0H7a.5.5 0 0 0-.5.5V7h-2a.5.5 0 0 0-.38.83l3.5 4a.5.5 0 0 0 .76 0l3.5-4a.5.5 0 0 0 .08-.54z",
  "M14.5 11a1 1 0 0 0-1 1v2h-11v-2a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"
];
export {
  download
};
//# sourceMappingURL=download.js.map
